import dagre from "@dagrejs/dagre";
import {Position} from "@xyflow/react";
import {arrays} from "@atttomyx/shared-utils";

export const applyVerticalLayout = (nodes, edges, size) => {
    return applyLayout(nodes, edges, false, size);
};

export const applyHorizontalLayout = (nodes, edges, size) => {
    return applyLayout(nodes, edges, true, size);
};

const applyLayout = (nodes, edges, horizontal, size) => {
    const modifiedNodes = [];

    if (nodes.length > 0) {
        const graph = new dagre.graphlib.Graph();
        const half = Math.ceil(size / 2);

        graph.setDefaultEdgeLabel(() => ({}));
        graph.setGraph({
            rankdir: horizontal ? "LR" : "TB",
            ranksep: size,
            nodesep: size,
            edgesep: size,
        });

        nodes.forEach((node) => {
            graph.setNode(node.id, {
                width: size,
                height: size,
            });
        });

        edges.forEach((edge) => {
            graph.setEdge(edge.source, edge.target);
        });

        dagre.layout(graph);

        nodes.forEach((node) => {
            const nodeWithPosition = graph.node(node.id);
            const modifiedNode = {...node};

            modifiedNode.sourcePosition = horizontal ? Position.Right : Position.Bottom;
            modifiedNode.targetPosition = horizontal ? Position.Left : Position.Top;

            modifiedNode.position = {
                x: nodeWithPosition.x - half,
                y: nodeWithPosition.y - half,
            };

            arrays.addTo(modifiedNodes, modifiedNode);
        });
    }

    return {
        nodes: modifiedNodes,
        edges: edges,
    };
};
